import { AutogenLayoutOrderPlanningProfileList } from "./autogen/AutogenLayoutOrderPlanningProfileList";
import { TableRowDisplayEvent } from "@mcleod/components";

export class OrderPlanningProfileList extends AutogenLayoutOrderPlanningProfileList {

    override onLoad() {
        this.mainDataSource.search({});
    }

    tableSearchOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const imageProfileColor = tableRow.findComponentById("imageProfileColor");
        if (imageProfileColor != null) {
            const profileColor = tableRow.data?.getString("profile_color", null);
            imageProfileColor.color = profileColor;
            imageProfileColor.visible = profileColor != null;
        }
    }
}
